export default function(elm) {
    // shows the first day of each year
    const positions = [];
    const startYear = new Date(elm.dataMin).getFullYear();
    const endYear = new Date(elm.dataMax).getFullYear();

    for (let year = startYear; year <= endYear; year++) {
        const janFirst = Date.UTC(year, 0, 1); // January 1st of each year
        positions.push(janFirst);
    }

    return positions;
}